const alphabet = "АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ";

const alphabetType2 = "#%&+Ђ=>?@£¤¥Ä»«ÆÞ<ÐЉ∑∞≠≈◊∫∅ẀÎĘŃ‡√";

const encryptWordType2 = (word: string): string[] => {
  return word
    .toUpperCase()
    .split("")
    .map((letter) => {
      const letterNumber = alphabet.indexOf(letter);

      if (letterNumber === -1) {
        throw new Error(`Неизвестная буква: ${letter}`);
      }

      return alphabetType2[letterNumber];
    });
};

export default encryptWordType2;